import { useEffect, useState } from 'react'

declare global {
  const FB: any
  interface Window {
    fbAsyncInit: () => void
  }
  interface Element {
    src: string
  }
}

export function useFacebookSdk(
  appId: string | undefined,
  apiVersion: string = 'v22.0',
  lang: string = 'en_US'
) {
  const [fbSdkReady, setFbSdkReady] = useState<boolean>(false)

  useEffect(() => {
    if (!appId) return
    window.fbAsyncInit = function () {
      FB.init({
        appId: appId,
        cookie: true,
        xfbml: true,
        version: apiVersion,
      })
      setFbSdkReady(true)
    }
    ;(function (d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = `https://connect.facebook.net/${lang}/sdk.js#xfbml=1&version=${apiVersion}`
      fjs?.parentNode?.insertBefore(js, fjs)
    })(document, 'script', 'facebook-jssdk')
  }, [appId])

  return { fbSdkReady }
}
